import { toast } from "react-toastify";

export const getFilterState = (key, defaults) =>
  window.localStorage.getItem(key)
    ? JSON.parse(window.localStorage.getItem(key))
    : defaults;

export const saveFilterState = (key, filters = {}) =>
  window.localStorage.setItem(key, JSON.stringify(filters));

export const customToast = {
  success: (message, autoClose = 1000) => {
    toast.success(message, { autoClose, pauseOnHover: false });
  },
  error: (
    message = "Sorry, something went wrong. Please contact your administrator",
    autoClose = 4000
  ) => {
    toast.error(message, { autoClose });
  },
  warning: (message, autoClose = 4000) => {
    toast.warning(message, { autoClose });
  }
};

export const cleanHTMLString = (value, removeLB = false) => {
  // If value is undefined, return empty string
  if (!value) {
    return "";
  }
  // Step 1: Create a temporary element (e.g., a div) and set its innerHTML to the HTML string
  const tempElement = document.createElement("div");
  tempElement.innerHTML = value;

  // Step 2: Get the text content of the temporary element, which will remove HTML tags
  const textContent = tempElement.textContent || tempElement.innerText;

  // Step 3: Replace special characters using the DOMParser to decode HTML entities
  const decodedString = new DOMParser().parseFromString(
    textContent,
    "text/html"
  ).body.textContent;

  const cleanedString = removeLB
    ? decodedString
        .replace(/[\r\n]+/g, " ")
        .replace(/\s+/g, " ")
        .trim()
    : decodedString;

  // Now 'cleanedString' contains the text content without HTML tags, decoded special characters,
  // and with line breaks and similar characters removed
  return cleanedString;
};

export const capitalizeEveryWord = (str) =>
  str.toLowerCase().replace(/\b[a-z]/g, (char) => char.toUpperCase());

export const stripHtml = (html) => {
  if (html) {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }
};

export function generateUniqueId(prefix = "") {
  const random = Math.random().toString(36).substring(2, 10);
  const timestamp = Date.now().toString(36);
  return prefix ? `${prefix}_${timestamp}${random}` : `${timestamp}${random}`;
}

export function escapeHTML(str) {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}
